module.exports = __webpack_public_path__ + "static/media/america.707b0e2f.png";